import React from "react"
import { observer } from "mobx-react"

import { onboardingStore } from "@src/widgets/onboarding/classes"
import { OnboardingTourModal } from "@src/widgets/onboarding/ui/tours/OnboardingTourModal"

const Onboarding: React.FC = observer(() => {
  const store = onboardingStore()

  if (store.isProgress && store.activeTour) {
    return (
      <OnboardingTourModal
        actions={{ next: () => store.next(), prev: () => store.back() }}
        tour={store.activeTour}
      />
    )
  }

  return null
})

export default Onboarding
